import {BigNumber} from 'ethers';

export enum EApiSourceName {
  TOKEN,
  SOLUTION,
  GFT_ROOT,
  PROVIDER,
  SIGNER,
}
export enum ETemplate {
  QUICKTOKEN = 'quicktoken',
  DEFAULT = 'default',
  DELLCOIN = 'dellcoin',
  FARM_XYZ = 'farmXYZ',
}

export type TLoginResponse = {
  accessToken: string;
};

export type TContractAddress = string;

export type TTokenAddress = string;

export type TInvestResponse = {
  id?: string;
  address: string;
  email: string;
  fullName: string;
  telegram: string;
  story?: string;
  networkId?: string;
  referralCode?: string;
};

export type TNetwork = {
  id: string;
  name: string;
  symbol: string;
  rpc: string;
  gftRootAddress: string;
};

export type TProjectExternal = {
  id?: string;
  createdAt: number;
  updatedAt?: number;
  projectId: string;
  isActive: boolean;
  network?: TNetwork;
};

export type TToken = {
  id?: string;
  symbol: string;
  icon?: string;
  address: string;
  decimals: number;
  network?: TNetwork;
};

export type TWithdrawal = {
  id?: string;
  sender: string;
  recipient: string;
  tokenAddresses: string[];
  amounts: string[];
  network?: TNetwork;
};

export type TProjectResponse = {
  id?: string;
  sync?: boolean;
  lastSyncAt?: number;
  title: string;
  description?: string;
  network?: string;
  minAmount?: string;
  maxAmount?: string;
  tgeDate?: string;
  tgeNetwork?: string;
  tgeToken?: string;
  info?: string;
  blockchainId?: string;
  owner?: string;
  hardCap?: string;
  startDate?: string;
  exchageRate?: string;
  defaultAmount?: string;
  endDate?: string;
  tokenIcon?: string;
  adminNotificationEmailReceivers?: string;
  adminNotificationEmailTemplate?: string;
  investorNotificationEmailSubject?: string;
  investorNotificationEmailTemplate?: string;
  successTitle?: string;
  successDescription?: string;
  isActive?: boolean;
  tokens?: TToken[];
  projectExternals?: TProjectExternal[];
  investments?: TInvestResponse[];
  withdrawals?: TWithdrawal[];
  template?: string;
};

export type TProjectProps = {
  projectOwner: string;
  hardCap: string;
  endDate: string;
  startDate: string;
  supportedTokens: TTokenAddress[];
};

export type TProject = {
  feePercent: BigNumber;
  isActive: boolean;
  props: TProjectProps;
  totalInvested: BigNumber;
};

export type TERC20Token = {
  decimals: number;
  symbol: string;
  address: TTokenAddress;
};

export type ContractApiArgs = {
  contractName: EApiSourceName;
  contractAddress?: string;
  method: string;
  callData?: any[];
};

export type TPokemonResponse = {
  count: number;
  next: string;
  previous: string;
  results: TPokemonItem[];
};

export type TPokemonMeta = {
  count: number;
  next: string;
  previous: string;
};

export type TPokemonItem = {
  name: string;
  url: string;
};

export type TPokemon = {
  abilities: any[];
  base_experience: number;
  forms: TPokemonItem[];
  game_indices: any[];
  height: string;
  held_items: any[];
  id: number;
  is_default: boolean;
  location_area_encounters: string;
  moves: any[];
  name: string;
  order: 1;
  past_types: any[];
  species: any;
  sprites: any;
  stats: any[];
  types: any[];
  weight: number;
};

export type TDefaultResponse<D = TDefaultData, M = TDefaultMeta> = {
  data: D;
  meta: M;
};

export type TDefaultData = {};

export type TDefaultMeta = {};
